//import React from 'react';
import React, {
  useState,
  useEffect,
} from 'react';

/*
import {
  TouchableOpacity,
  View,
  Text,
} from 'react-native';
*/

//import Icon from 'react-native-vector-icons/FontAwesome';

import RNDropzone from 'react-dropzone';
import FileSaver from 'file-saver';

import * as Victory from 'victory';
import { Rnd } from 'react-rnd';

import ff from './ff';
import bf from './bf';
import ic from './ic';

export default class df { // environment dependent function

static Dzn = RNDropzone;
static Vry = Victory;

static myFL_ept(pd={ // export file, only for web
  fileName: '',
  val: '',
}) {
  let _bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let _blob = new Blob([_bom, pd.val], {type: "text/plain;charset=utf-8"});
  FileSaver.saveAs(_blob, pd.fileName);
};

static Rdv = (pd={ // resizable and druggable view
  b_vsb: false,
  b_edt: false,
  d_iniMsrs: {
    n_x: 0,
    n_y: 0,
    n_w: 0,
  },
  d_msrs: {
    n_x: 0,
    n_y: 0,
    n_w: 0,
  },  
  n_o: ic.gn_mgnNrm, // offset
  n_d: 50,
  n_h: 0,
}) => {

  const [_sd_msrs, _setMsrs] = useState({
    n_x: 0,
    n_y: pd.n_o ?? 0,
    n_w: pd.n_d,
  });

  useEffect(() => {
    if (pd.d_msrs) {
      _setMsrs(pd.d_msrs)
    };
  }, [
    pd.d_msrs,
  ])

  if (pd.b_vsb == false) return null;

  let _btnIconSize = pd.n_d - ic.gn_mgnNrm / 2 * 2;

  return (
    React.createElement(Rnd, {
      key: 'Rdv',
      default: {
        x: 0, 
        y: pd.n_o ?? 0,
        width: pd.n_d, 
        height: pd.n_h,
      },
      size: {
        width: _sd_msrs?.n_w, 
        height: pd.n_h,
      },
      position: {
        x: _sd_msrs?.n_x, 
        y: _sd_msrs?.n_y + (pd.n_o ?? 0),
      },
      dragAxis: 'x',
      enableResizing: {
        top: false, right: true, bottom: false, left: true,
        topRight: false, bottomRight: false, bottomLeft: false, topLeft: false
      },
      bounds: "parent",
      resizeGrid: [(pd.b_edt) ? pd.n_d : 0, 0],
      dragGrid: [(pd.b_edt) ? pd.n_d : 0, 0],
      minWidth: pd.n_d,
      minHeight: pd.n_h,
      onResize: (_e, _direction, _ref, _delta, _position) => {
        if (pd.b_edt) {
          let _d_msrs = {
            n_x: _position.x, 
            n_y: _position.y - (pd.n_o ?? 0),
            n_w: ff.myCM_cnv('px-msr', _ref.style.width), 
          };
          _setMsrs(_d_msrs);
          pd.o_onChg(_d_msrs);
        };
      },
      onDrag: (_e, _d) => {
        if (pd.b_edt) {
          let _d_msrs = {
            n_x: _d.x, 
            n_y: _d.y - (pd.n_o ?? 0),
            n_w: _sd_msrs.n_w, 
          };
          _setMsrs(_d_msrs);
          pd.o_onChg(_d_msrs);
        };
      },
      onDragStop: (_e, _d) => {
        if (pd.b_edt) {
          if ( _d.x == _sd_msrs.n_x && (_d.y - (pd.n_o ?? 0)) == _sd_msrs.n_y) { // 位置の変更がない場合、click と判定
            if (pd.o_onPrs) pd.o_onPrs(_sd_msrs);
          }
        };
      },
      style: {
        backgroundColor: '#f2a0a1',
        borderRadius: ic.gn_bdrRdsNrm,
      },
    }, [
      pd.children
    ])
  )
};

static myWB_getDmn = () => { // get domain
  let _dmn = document.domain;
  return {
    dmn: _dmn, 
    subDmn: String(_dmn).substring(0, _dmn.indexOf('.')),
  };
};

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
